import React from 'react';

function FAQBlock() {
   return (
      <section className="w-full bg-light-6 py-12 md:py-16 lg:py-24 px-6 text-center">
         <p className="text-normal text-dark-3">
            💡 Tu as une question fréquente ? Jette un œil à notre{" "}
            <a href="/help-center" className="text-blue-1 font-semibold hover:underline">Centre d’aide</a> avant de nous écrire.
         </p>
      </section>
   )
};

export default FAQBlock;